import { signingProviderConstants } from "../../../constants/SigningProviderConstants";

export const initialSigningProviderState = {
  providers: [],
  representatives: [],
  selectedProvider: null,
  signingCase: null,
  loading: false,
  error: "",
  validationMessages: {},
};

const signingProviderReducer = (
  state = initialSigningProviderState,
  action
) => {
  switch (action.type) {
    case signingProviderConstants.PROVIDERS_REQUEST:
    case signingProviderConstants.REPRESENTATIVES_REQUEST:
    case signingProviderConstants.SIGNING_CASE_REQUEST:
      return { ...state, loading: true, error: "" };
    case signingProviderConstants.PROVIDERS_SUCCESS:
      return { ...state, providers: action.providers, loading: false };
    case signingProviderConstants.REPRESENTATIVES_SUCCESS:
      return {
        ...state,
        representatives: action.representatives,
        loading: false,
      };
    case signingProviderConstants.PROVIDERS_FAILURE:
    case signingProviderConstants.REPRESENTATIVES_FAILURE:
      return { ...state, loading: false, error: action.error };
    case signingProviderConstants.SELECT_PROVIDER:
      return {
        ...state,
        selectedProvider: action.provider,
        validationMessages: {},
      };
    case signingProviderConstants.SIGNING_CASE_SUCCESS:
      return {
        ...state,
        signingCase: action.signingCase,
        // No backend-confirmed case means nothing to resume — never trust a
        // stale in-memory selection, otherwise the provider picker is skipped.
        selectedProvider: action.signingCase
          ? {
              id: action.signingCase.providerId,
              name: action.signingCase.providerName,
            }
          : null,
        loading: false,
        validationMessages: {},
      };
    case signingProviderConstants.SIGNING_CASE_FAILURE:
      return {
        ...state,
        loading: false,
        validationMessages: action.validationMessages,
      };
    case signingProviderConstants.SIGNING_CASE_CANCEL_SUCCESS:
      return {
        ...initialSigningProviderState,
        providers: state.providers,
        representatives: state.representatives,
      };
    case signingProviderConstants.SIGNING_FLOW_RESET:
      return initialSigningProviderState;
    default:
      return state;
  }
};

export default signingProviderReducer;
